// front/src/pages/Dashboard-ES/DashboardES.styles.js
import styled from 'styled-components';

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f9f9f9;

  .main-content {
    flex: 1;
    margin-left: 300px;
    margin-top: 55px; /* Altura do Navbar */
    padding: 20px;
    overflow-y: auto;
    background-color: #f9f9f9;
    min-height: calc(100vh - 55px); /* Altura total menos Navbar */

    @media (max-width: 768px) {
      margin-left: 150px;
      margin-top: 50px; /* Altura menor do Navbar em mobile */
      padding: 15px;
      min-height: calc(100vh - 50px);
    }

    @media (max-width: 480px) {
      margin-left: 0;
      margin-top: 50px;
      padding: 10px;
      min-height: calc(100vh - 50px);
    }
  }
`;